import { render, staticRenderFns } from "./ManageMerchantOrganisms.vue?vue&type=template&id=15ef03a6&scoped=true"
import script from "./ManageMerchantOrganisms.vue?vue&type=script&lang=js"
export * from "./ManageMerchantOrganisms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef03a6",
  null
  
)

export default component.exports